import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MCButtonComponent, MCDialogComponent, MCFormFieldWrapperComponent, McAutocompleteComponent, McInfoComponent } from '@maslul/common-components';
import { InputTextModule } from 'primeng/inputtext';
import { Router } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MCCodeListWrapperService, MCDialog, MCDialogButton, MCDialogFooter, MCDialogHeader, SelectItemNested, Utils } from '@maslul/common-services';
import { RequestApprovalTypeDetails, RequestApprovalTypeDetailsStore } from '../../../../../services/store/approval-type-details-store';
import { Subscription } from 'rxjs';
import { ValidationMessageData } from '../../../../../resources/validation-massage';
import { ApprovalTypeService } from '../../../../../services/pages/approval-type/approval-type.service';
import { TranslateService } from '@ngx-translate/core';
import { SecondRequest } from '../../../../../models/request-submission-methods/approvalType/secondRequest';
import { FocusOnTabDirective } from '../../../../../services/shared/directives/focus-on-tab';
import { ApprovalTypesService } from '../../../../../services/approval-type/approval-type';
import { RequestSubmissionMethodsSkeletonComponent } from '../../components/request-submission-methods/skeleton/skeleton';


@Component({
    selector: 'mi-request-submission-methods',
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MCButtonComponent,
        McAutocompleteComponent,
        AutoCompleteModule,
        McInfoComponent,
        InputTextModule,
        MCFormFieldWrapperComponent,
        RequestSubmissionMethodsSkeletonComponent,
        FocusOnTabDirective,
        MCDialogComponent],
    providers: [],
    templateUrl: './request-submission-methods.html',
    styleUrl: './request-submission-methods.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
//todo: use base
export class RequestSubmissionMethodsComponent implements OnInit, OnDestroy {

    authoritySearchQuery: string = "";
    public customErrorMessages = ValidationMessageData.customErrorMessages
    genericText: any;
    requestSubmissionMethodsText: any;
    dialogProperties: MCDialog = new MCDialog();

    constructor(
        private router: Router,
        private codeListService: MCCodeListWrapperService,
        private approvalTypeService: ApprovalTypeService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private translateService: TranslateService,
        private approvalTypesService: ApprovalTypesService
    ) {

    }
    authorities: SelectItemNested[] = [];
    authorityInfo: string | undefined;
    filteredAuthorities: SelectItemNested[] = [];
    selectedAuthority: SelectItemNested | undefined;
    subscribtion: Subscription = new Subscription();
    endedLoading: boolean = false;


    ngOnInit(): void {
        this.initText();
        this.init();
    }

    initText() {
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('requestSubmissionMethods').subscribe(translation => {
            this.requestSubmissionMethodsText = translation;
        }));

    }

    init() {
        this.initSubscriptions();
        this.initDialog();
    }

    initSubscriptions() {
        this.subscribtion.add(
            this.codeListService.getAuthorityWithApproval(false).subscribe((authoritiesWithApproval: SelectItemNested[]) => {
                this.authorities = authoritiesWithApproval;
                this.filteredAuthorities = this.authorities;
                this.initAuthoritySelected();
                this.endedLoading = true;
            })
        )


    }

    selectSingelAuthority() {
        if (this.authorities?.length == 1) {
            this.selectedAuthority = this.authorities[0];
            this.authoritySelected();
        }
    }

    initAuthoritySelected() {
        const existingAuthorityId = this.requestApprovalTypeDetailsStore.getSnapshot().authorityId;
        if (existingAuthorityId) {
            this.selectedAuthority = this.authorities.find(auth => auth.value == existingAuthorityId);
        } else {
            this.selectSingelAuthority();
        }
    }

    searchAuthorities(event: any) {
        const filteredAuthorities: SelectItemNested[] = [];
        this.authoritySearchQuery = event.query.toLowerCase();

        for (let i = 0; i < this.authorities.length; i++) {
            const authority = this.authorities[i];
            if (authority.label?.toLowerCase().includes(this.authoritySearchQuery)) {
                filteredAuthorities.push(authority);
            }
        }

        this.filteredAuthorities = filteredAuthorities;
    }
    initDialog() {
        this.dialogProperties.breakpoints = {
            '960px': '75vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
    }
    showDialogOnAuthoritySelectedChange(dialogProperties: MCDialog, dialogText: any, authorityIdFromStore: string) {
        dialogProperties.visible = true;
        dialogProperties.header = new MCDialogHeader();
        dialogProperties.header.closeButton = new MCDialogButton();
        dialogProperties.header.closeButton.label = "X";
        dialogProperties.header.closeButton.event = () => {
            this.changeAuthoritySelectedCancle(dialogProperties, authorityIdFromStore);
        };
        dialogProperties.footer = new MCDialogFooter();
        dialogProperties.footer.button = new MCDialogButton();
        dialogProperties.footer.button.label = dialogText.okButton;
        dialogProperties.footer.button.event = () => {
            this.changeAuthoritySelectedOK(dialogProperties);
        };
        dialogProperties.footer.secondButton = new MCDialogButton();
        dialogProperties.footer.secondButton.label = dialogText.cancelButton;
        dialogProperties.footer.secondButton.class = "mi-white-button";
        dialogProperties.footer.secondButton.event = () => {
            this.changeAuthoritySelectedCancle(dialogProperties, authorityIdFromStore);
        };
    }

    changeAuthoritySelectedOK(dialogProperties: MCDialog) {
        this.approvalTypesService.clearStoreOnApprovalChange();
        this.authoritySelected();
        dialogProperties.visible = false
    }

    changeAuthoritySelectedCancle(dialogProperties: MCDialog, authorityIdFromStore: string) {
        this.selectedAuthority = this.authorities.find(item => item.value?.toString() == authorityIdFromStore);
        dialogProperties.visible = false
    }

    onSelectAuthority() {
        const authorityIdFromStore = this.requestApprovalTypeDetailsStore.getSnapshot().authorityId;
        if (authorityIdFromStore && this.selectedAuthority?.value.toString() !== authorityIdFromStore.toString()) {
            this.showDialogOnAuthoritySelectedChange(this.dialogProperties, this.requestSubmissionMethodsText.dialogAutorityChanged, authorityIdFromStore);
        }
        else {
            this.authoritySelected();
        }


    }

    authoritySelected() {
        this.setAuthorityAndMainTypeDetails();
        this.setAuthorityInfo();
    }

    getSecondApprovalTypes() {
        const approvalTypesJson = this.selectedAuthority?.items[0].additionalColumns['ApprovalTypes']
        const approvalTypes = JSON.parse(approvalTypesJson);
        const secondApproval = approvalTypes.map((x: any) => new SecondRequest(x.Id, x.Name, x.MIApprovalTypeDescription, x.Secondary, x.CustomItem4Digits))
        return secondApproval;
    }

    setAuthorityAndMainTypeDetails() {
        this.requestApprovalTypeDetailsStore.setAuthorityId(this.selectedAuthority?.value || "");
        this.requestApprovalTypeDetailsStore.setTypeCode(this.selectedAuthority?.items[0].additionalCode || "");
        this.requestApprovalTypeDetailsStore.setApprovalMainTypeName(this.selectedAuthority?.items[0].label || "");
        const secondApproval = this.getSecondApprovalTypes();
        this.requestApprovalTypeDetailsStore.setApprovalTypes(secondApproval || []);
    }

    setAuthorityInfo() {
        const requestApprovalTypeDetails: RequestApprovalTypeDetails = this.requestApprovalTypeDetailsStore.getSnapshot();
        const authorityKey = Utils.padZero(requestApprovalTypeDetails.authorityId)
        this.approvalTypeService.getInfoByKey(authorityKey).subscribe((info: string) => {
            this.authorityInfo = info;
        });
    }

    disabledChoosApprovalType(): boolean {
        return !this.selectedAuthority?.value;
    }

    navigation(path: string) {
        this.router.navigate([`/${path}`])
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}
